<template>
  <div class="home">
    <div class="part-1">
      <Carousel v-model="value2" loop autoplay  autoplay-speed = "4000">
        <CarouselItem>
          <div class="demo-carousel csel-1">
            <div class="main">
              <div class="left">
                <p class="p-1">{{ $t('home.slider1.title') }}</p>
                <p class="p-2">{{ $t('home.slider1.description') }}</p>
              </div>
              <div class="right">
                <img src="../assets/images/home/home-banner-1.png" alt />
              </div>
            </div>
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel csel-2">
            <div class="main">
              <div class="left">
                <p class="p-1">{{ $t('home.slider2.title') }}</p>
                <p class="p-2">{{ $t('home.slider2.description') }}</p>
              </div>
              <div class="right">
                <img src="../assets/images/home/home-banner-2.png" alt />
              </div>
            </div>
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel csel-3">
            <div class="main">
              <div class="left">
                <p class="p-1">{{ $t('home.slider3.title') }}</p>
                <p class="p-2">{{ $t('home.slider3.description') }}</p>
              </div>
              <div class="right">
                <img src="../assets/images/home/home-banner-3.png" alt />
              </div>
            </div>
          </div>
        </CarouselItem>
      </Carousel>
    </div>
    <div class="part-2">
      <div class="main">
        <div class="content">
          <div class="left">
            <p class="p-1">{{ $t('home.part1.title') }}</p>
            <p class="p-2">{{ $t('home.part1.description') }}</p>
            <div class="btn">
              <a
                v-show="downcn"
                href="https://static.sdchain.io/files/SixDomainChain_WhitePaper_CN.pdf"
                download="Co-Chain.pdf"
              >
                {{ $t('home.part1.white') }}
                <i class="iconfont icon-xiazai1"></i>
              </a>
              <a
                v-show="downen"
                href="https://static.sdchain.io/files/SDChain_Whitepaper_EN.pdf"
                download="SDChain_Whitepaper_EN"
              >
                {{ $t('home.part1.white') }}
                <i class="iconfont icon-xiazai1"></i>
              </a>
            </div>
          </div>
          <div class="right">
            <video
              v-show="video1"
              src="https://sdchain.oss-cn-shanghai.aliyuncs.com/static/video/sdc_intro_20180111.mp4"
              controls
              poster="../assets/images/home/video_index.jpg"
              style="object-fit: fill;"
            ></video>
            <video
              v-show="video2"
              src="https://sdchain.oss-cn-shanghai.aliyuncs.com/static/video/sdchain_intro_en.mp4"
              controls
              poster="../assets/images/home/video_index.jpg"
              style="object-fit: fill;"
            ></video>
          </div>
        </div>
      </div>
    </div>

    <div class="part-4">
      <div class="main">
        <p class="tit">{{ $t('home.part3.head') }}</p>
        <p class="desc">{{ $t('home.part3.desc') }}</p>
        <div class="content">
          <div class="item">
            <div class="icof">
              <img src="../assets/images/home/part4-1.png" alt />
            </div>
            <p class="title">{{ $t('home.part3.title1') }}</p>
            <p class="descb">{{ $t('home.part3.description1') }}</p>
          </div>
          <div class="item">
            <div class="icof">
              <img src="../assets/images/home/part4-2.png" alt />
            </div>
            <p class="title">{{ $t('home.part3.title2') }}</p>
            <p class="descb">{{ $t('home.part3.description2') }}</p>
          </div>
          <div class="item">
            <div class="icof">
              <img src="../assets/images/home/part4-3.png" alt />
            </div>
            <p class="title">{{ $t('home.part3.title3') }}</p>
            <p class="descb">{{ $t('home.part3.description3') }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="part-3">
      <div class="main">
        <p class="tit">{{ $t('home.part2.head') }}</p>
        <p class="desc">{{ $t('home.part2.desc') }}</p>
        <div class="content">
          <div class="item">
            <img src="../assets/images/home/part3-1.png" alt />
            <p class="p-1">{{ $t('home.part2.title1') }}</p>
            <p class="p-2">{{ $t('home.part2.description1') }}</p>
          </div>
          <div class="item">
            <img src="../assets/images/home/part3-2.png" alt />
            <p class="p-1">{{ $t('home.part2.title2') }}</p>
            <p class="p-2">{{ $t('home.part2.description2') }}</p>
          </div>
          <div class="item">
            <img src="../assets/images/home/part3-3.png" alt />
            <p class="p-1">{{ $t('home.part2.title3') }}</p>
            <p class="p-2">{{ $t('home.part2.description3') }}</p>
          </div>
          <div class="item">
            <img src="../assets/images/home/part3-4.png" alt />
            <p class="p-1">{{ $t('home.part2.title4') }}</p>
            <p class="p-2">{{ $t('home.part2.description4') }}</p>
          </div>
          <div class="item">
            <img src="../assets/images/home/part3-5.png" alt />
            <p class="p-1">{{ $t('home.part2.title5') }}</p>
            <p class="p-2">{{ $t('home.part2.description5') }}</p>
          </div>
          <div class="item">
            <img src="../assets/images/home/part3-6.png" alt />
            <p class="p-1">{{ $t('home.part2.title6') }}</p>
            <p class="p-2">{{ $t('home.part2.description6') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CarouselItem, Carousel } from "iview";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";

export default {
  name: "home",
  components: {
    CarouselItem,
    Carousel
  },
  data() {
    return {
      value2: 0,
      downcn: false,
      downen: false,
      video1:false,
      video2:false,
    };
  },
  created() {
    this.getDown();
    this.getMp4();
  },
  mounted() {},
  methods: {
    getDown() {
      if (localStorage.Lang == "cn" || localStorage.Lang == "tw") {
        this.downcn = true;
      } else {
        this.downen = true;
      }
    },
    getMp4(){
      if (localStorage.Lang == "cn" || localStorage.Lang == "tw") {
        this.video1 = true;
      } else {
        this.video2 = true;
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../assets/css/var.less");
.home {
  .part-1 {
    height: 599px;
    z-index: -1;
    .csel-1 {
      height: 599px;
      background: linear-gradient(
        81deg,
        rgba(85, 47, 194, 1),
        rgba(22, 127, 221, 1)
      );
      .main {
        .clearfix();
        .left {
          float: left;
          width: 55%;
          color: #fff;
          padding-top: 250px;
          text-align: left;
          padding-left: 60px;
          vertical-align: middle;
          .p-1 {
            font-size: 64px;
         
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
          .p-2 {
            font-size: 22px;
          
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
        }
        .right {
          float: left;
          width: 45%;
          text-align: left;
          vertical-align: middle;
          margin-top: 160px;
          img {
            width: 441px;
            height: 348px;
          }
        }
      }
    }
    .csel-2 {
      height: 599px;
      background: linear-gradient(
        81deg,
        rgba(7, 145, 242, 1),
        rgba(41, 176, 246, 1)
      );
      .main {
        .clearfix();
        .left {
          float: left;
          width: 55%;
          color: #fff;
          padding-top: 250px;
          text-align: left;
          padding-left: 60px;
          vertical-align: middle;
          .p-1 {
            font-size: 64px;
     
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
          .p-2 {
            font-size: 22px;
          
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
        }
        .right {
          float: left;
          width: 45%;
          text-align: left;
          vertical-align: middle;
          margin-top: 111px;
          img {
            width: 443px;
            height: 412px;
          }
        }
      }
    }
    .csel-3 {
      height: 599px;
      background: linear-gradient(
        81deg,
        rgba(55, 113, 255, 1),
        rgba(24, 144, 255, 1)
      );
      .main {
        height: 100%;
        .clearfix();
        .left {
          float: left;
          width: 55%;
          color: #fff;
          padding-top: 250px;
          text-align: left;
          padding-left: 60px;
          vertical-align: middle;
          .p-1 {
            font-size: 64px;
        
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
          .p-2 {
            font-size: 22px;
        
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
        }
        .right {
          float: left;
          width: 45%;
          text-align: left;
          vertical-align: middle;
          margin-top: 136px;
          img {
            width: 468px;
            height: 407px;
          }
        }
      }
    }
  }
  .part-2 {
    height: 600px;
    position: relative;
    background-color: #fff;
    img {
      width: 1209px;
      height: 444px;
      margin: 0 auto;
      display: block;
      margin-top: -30px;
    }
    .main {
      position: absolute;
      left: 50%;
      top: 0;
      transform: translate(-50%, 0);
      height: 100%;
      width: 100%;
      padding: 0;
      .content {
        .clearfix();
        .right {
          float: right;
          width: 55%;
          text-align: left;
          embed {
            height: 100px;
            width: 100%;
          }
          video {
            height: 338px;
            width: 601px;
            position: relative;
            top: 100px;
          }
        }
        .left {
          float: left;
          width: 45%;
          padding-right: 40px;
          .p-1 {
            padding-top: 102px;
            font-size: 30px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
          .p-2 {
            //text-align: justify;
            text-align: left;
            padding-top: 25px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(85, 85, 85, 1);
            line-height: 1.8;
          }
          .btn {
            text-align: center;
            margin-top: 30px;
            width: 220px;
            height: 56px;
            background: rgba(80, 145, 253, 1);
            cursor: pointer;
            a {
              line-height: 56px;
              font-size: 22px;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              i {
                font-size: 22px;
                color: #fff;
                padding-left: 8px;
              }
            }
          }
        }
      }
    }
  }
  .part-3 {
    height: 850px;
    background-color: #fff;
    .main {
      overflow: hidden;
      padding: 0;
    }
    .fenge {
      .fgx();
    }
    .tit {
      margin-top: 89px;
      font-size: 30px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      text-align: center;
    }
    .desc {
      margin-top: 15px;
      font-size: 20px;
      font-weight: 400;
      color: rgba(85, 85, 85, 1);
      text-align: center;
    }
    .content {
      .clearfix();
      .item {
        float: left;
        width: 33.3333333333333%;
        height: 320px;
        text-align: center;
        padding: 0 35px;
        img {
          margin-top: 58px;
          height: 65px;
        }
        .p-1 {
          margin-top: 38px;
          font-size: 24px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
        .p-2 {
          margin-top: 15px;
          font-size: 16px;
          font-weight: 400;
          //text-align: justify;
          text-align: left;
          color: rgba(85, 85, 85, 1);
        }
      }
    }
  }
  .part-4 {
    height: 839px;
    background-color: #f3f6fb;
    .main {
      overflow: hidden;
      padding: 0;
    }
    .fenge {
      .fgx();
    }
    .tit {
      font-size: 30px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      margin-top: 89px;
      text-align: center;
    }
    .desc {
      font-size: 20px;
      font-weight: 400;
      color: rgba(85, 85, 85, 1);
      text-align: center;
      margin-top: 12px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      margin-top: 55px;
      padding: 5px 5px;
      .item {
        width: 354px;
        height: 550px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
        text-align: center;
        &:hover {
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        }
        .icof {
          margin: 0 auto;
          margin-top: 18px;
          text-align: center;
          width: 324px;
          height: 315px;
          background: #f7faff;
          position: relative;
          img {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .title {
          margin-top: 20px;
          text-align: left;
          font-size: 24px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          padding-left: 40px;
          padding-right: 36px;
        }
        .descb {
          margin-top: 10px;
          //text-align: justify;
          text-align: left;
          font-size: 16px;
          font-weight: 400;
          color: rgba(85, 85, 85, 1);
          padding-left: 40px;
          padding-right: 30px;
        }
      }
    }
  }
}
/deep/.ivu-carousel-dots-inside {
  bottom: 135px;
}
/deep/.ivu-carousel-dots-inside {
  bottom: 30px;
}
/deep/.ivu-carousel-dots li.ivu-carousel-active > button {
  background-color: #fff;
}
/deep/.ivu-carousel-dots li button {
  background-color: #ffffff;
}
</style>
